import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import targetWords from "../database/targetWords";

const secretKey = "my little secret";

export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  return encryptedData;
};

export const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};

function shuffleWord(word) {
  const characters = word.split("");

  for (let i = characters.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }

  const shuffledWord = characters.join("");
  return shuffledWord;
}

const initialState = localStorage.getItem("targetWord")
  ? JSON.parse(localStorage.getItem("targetWord"))
  : {
      targetWord: encryptData(
        targetWords[Math.floor(Math.random() * targetWords.length)]
      ),
      shuffleTargetWord: "",
    };

const targetWordSlice = createSlice({
  name: "targetWordSlice",
  initialState,
  reducers: {
    setTargetWord: (state, action) => {
      if (!localStorage.getItem("targetWord")) {
        state.targetWord = encryptData(
          targetWords[Math.floor(Math.random() * targetWords.length)]
        );
        state.shuffleTargetWord = shuffleWord(decryptData(state.targetWord));
        localStorage.setItem("targetWord", JSON.stringify(state));
        return state;
      }
    },
    resetTargetWord:(state,action)=>{
      state.targetWord="";
      state.shuffleTargetWord="";
      localStorage.removeItem("targetWord");
      return state;
    }
  },
});
export const { setTargetWord ,resetTargetWord} = targetWordSlice.actions;
export default targetWordSlice;
